import { render, staticRenderFns } from "./PrimaryTextBtn.vue?vue&type=template&id=7b5b39ca&scoped=true"
import script from "./PrimaryTextBtn.vue?vue&type=script&lang=js"
export * from "./PrimaryTextBtn.vue?vue&type=script&lang=js"
import style0 from "./PrimaryTextBtn.vue?vue&type=style&index=0&id=7b5b39ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b5b39ca",
  null
  
)

export default component.exports